/**
 * Zone.js performance tuning.
 *
 * This file runs AFTER zone.js (it's a polyfill entry in angular.json).
 * It restores native browser APIs that zone.js patches, preventing
 * unnecessary Angular change detection cycles from high-frequency
 * or animation-related callbacks.
 */

// ── Restore native requestAnimationFrame / cancelAnimationFrame ──
// Zone.js saves the originals under __zone_symbol__ before patching.
// Restoring them means rAF callbacks will NOT trigger change detection.
const nativeRAF = (window as any).__zone_symbol__requestAnimationFrame;
const nativeCAF = (window as any).__zone_symbol__cancelAnimationFrame;

if (nativeRAF) {
  window.requestAnimationFrame = nativeRAF;
  window.cancelAnimationFrame = nativeCAF;
}
